<template>
    <SlpBaseCard>
        <template #header>
            <SvgoBusPlaceholder filled :font-controlled="false" />
        </template>
        <template #class>
            <USkeleton class="my-1 h-2 w-[250px]" />
        </template>

        <template #model>
            <USkeleton class="my-1.5 h-3 w-[150px]" />
        </template>

        <template #registration>
            <USkeleton class="my-1 h-2 w-[40px]" />
        </template>

        <template #kilometer>
            <USkeleton class="my-1 h-2 w-[40px]" />
        </template>

        <template #euro-norm>
            <USkeleton class="my-1 h-2 w-[40px]" />
        </template>

        <template #price>
            <USkeleton class="my-2.5 h-6 w-[100px]" />
        </template>

        <template #status>
            <USkeleton class="my-1 h-2 w-[40px]" />
        </template>
    </SlpBaseCard>
</template>
